export default "__VITE_ASSET__0342170c__"